module.exports = __webpack_public_path__ + "images/category_lp/home_appliance/new/store_images/2_4124e7e466abf875d7d36f5f630b58e1.png";